import { computed } from 'mobx';
import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class RoleListDataService extends DataService<typeof Model.Core.Logic.ViewModels.Security.RoleSummary, Model.Core.Logic.ViewModels.Security.RoleSummary, RoleSummary> {
	protected map(entity: Model.Core.Logic.ViewModels.Security.RoleSummary): RoleSummary {
		return new RoleSummaryModel(entity);
	}

	public static make(context?: any): RoleListDataService {
		return new RoleListDataService(context, ctx => ctx.RolesSummaries);
	}
}

export class RoleSummaryModel extends EntityModel<Model.Core.Logic.ViewModels.Security.RoleSummary, RoleSummary> implements RoleSummary {
	@property<RoleSummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<RoleSummaryModel>(o => o.entity.displayName, (o, value) => o.entity.displayName = value)
	public displayName: string;

	@property<RoleSummaryModel>(o => o.entity.isRole, (o, value) => o.entity.isRole = value)
	public isRole: boolean;

	@property<RoleSummaryModel>(o => o.entity.isAdmin, (o, value) => o.entity.isAdmin = value)
	public isAdmin: boolean;

}



// WEBPACK FOOTER //
// ./src/app/general/roles/list/role-list.data.ts